
import { defineComponent, ref, provide } from "vue";

export default defineComponent({
  setup() {
    const setting = ref("black");
    provide("storeSetting", setting);
  },
});
